function isObject(arg) {
  return typeof arg === "object" && arg != null;
}

export { isObject };
